import { App } from "app-interfaces";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import Popup from "reactjs-popup";

import { useStateValue } from "../../config/AppContext";
import Icons from "./Icons";

type ParamsVoidFunction = (args: any) => void;
type EditToggleProps = {
  show: boolean;
  id: string;
  currentPath: string;
  action: ParamsVoidFunction | VoidFunction;
};

export default function EditToggleComponent(props: EditToggleProps) {
  const [createYear, setcreateYear] = useState([] as any);
  const { clients } = useStateValue() as {
    clients: App.State["clients"];
  };
  useEffect(() => {
    const client_created_date = clients?.find((v: any) => v.id === props.id);
    let created_date = client_created_date?.created_date?.toString();
    let date1 = new Date(created_date ? created_date : "");
    let date2 = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
    let yearsDiff = date2.getFullYear() - date1.getFullYear();
    let tmp = [];
    for (var i = 0; i <= yearsDiff; ++i) {
      tmp.push(date2.getFullYear() - i);
    }
    setcreateYear(tmp);
  }, [clients, props.id]);

  const { ic_menu, ic_menu_white, ic_edit, ic_edit_white, ic_share } = Icons;
  const { t } = useTranslation();
  if (!props.show) return null;
  switch (props.currentPath) {
    case "client-sessions":
      const handleSelect = (e: React.ChangeEvent<HTMLSelectElement>, close: () => void) => {
        e.preventDefault();

        close();
        return props.action({ currentYear: e.currentTarget.value });
      };

      return (
        <Popup
          position="bottom right"
          trigger={
            <div className="menu-icon">
              <img src={window.innerWidth > 700 ? ic_menu_white : ic_menu} alt="menu" />
            </div>
          }
          contentStyle={{
            width: "130px",
            listStyle: "none",
            padding: "0px",
            borderRadius: "5px",
          }}
        >
          {(close) => (
            <select
              className="form-control"
              defaultValue={new Date().getFullYear()}
              onChange={(e) => handleSelect(e, close)}
            >
              <option value={new Date().getFullYear()}>
                {t("Select")} {t("year")}
              </option>

              {createYear.length &&
                createYear.map((v: any, i: any) => (
                  <option key={i} value={v}>
                    {v}
                  </option>
                ))}
            </select>
          )}
        </Popup>
      );
    case "workouts":
      return (
        <Popup
          position="bottom right"
          trigger={
            <div className="menu-icon">
              <img src={ic_menu} alt="menu" />
            </div>
          }
          contentStyle={{
            width: "80px",
            listStyle: "none",
            textAlign: "center",
            paddingRight: "5px",
            borderRadius: "5px",
          }}
        >
          <ul style={{ marginBottom: "0" }}>
            <li onClick={props.action}>
              <NavLink className="menu-edit" to={`/${props.currentPath}/edit/${props.id}`}>
                <img alt="edit" src={ic_edit_white} />
              </NavLink>
            </li>
            <li>
              <NavLink className="menu-share" to={`/${props.currentPath}/share/${props.id}`}>
                <img alt="share" src={ic_share} />
              </NavLink>
            </li>
          </ul>
        </Popup>
      );
    default:
      return (
        <span className="edit" onClick={props.action}>
          <NavLink to={`/${props.currentPath}/edit/${props.id.replace("sessions/", "")}`}>
            <img alt="edit" src={ic_edit} />
          </NavLink>
        </span>
      );
  }
}
